/**
 * TRANSPORTLAUFZEITEN JE IMPORTWEG -- die EINE Stelle dafür (Importweg-UI 001).
 *
 * Heute sind die Laufzeiten nirgends modelliert: weder im Parametersatz noch
 * an Lieferant oder Artikel. Sie sind eine fachliche Richtgröße von 02 vom
 * 19.09.2026 und stehen deshalb hier -- einmal, statt verstreut in Karten und
 * Texten. Die Oberfläche formuliert sie („ca. 60 Tage"), rechnet aber nicht
 * mit ihnen.
 *
 * Empfehlung für später: als zentrale Kalkulationsparameter je Transportart
 * führen (Tage, versioniert wie die Frachtsätze), damit eine geänderte
 * Laufzeit ein Parameterstand ist und keine Codeänderung.
 */
export type Importweg = "sea" | "train" | "air";

export const TRANSPORTLAUFZEIT: Readonly<Record<Importweg, { readonly wert: number; readonly einheit: "tage" | "wochen" }>> = {
  sea:   { wert: 60, einheit: "tage" },
  train: { wert: 20, einheit: "tage" },
  air:   { wert: 1,  einheit: "wochen" },
};
